import { useEffect } from 'react';
import { toAgentSummary } from 'semantic-dom-ssg';
import { useSemanticDOM } from 'semantic-dom-ssg/react';

const semanticConfig = {
  computeBounds: false,
  includeStateGraph: true,
  generateIds: true,
  idPrefix: 'consltr',
  validate: true,
  targetCertification: 'standard' as const,
};

const SemanticDOMBridge = () => {
  const { parse } = useSemanticDOM(semanticConfig);

  useEffect(() => {
    const publishSemanticDocument = () => {
      const semanticDocument = parse(document.body, window.location.href, document.title);
      const summary = toAgentSummary(semanticDocument);
      const payload = {
        standard: semanticDocument.standard,
        url: semanticDocument.url,
        title: semanticDocument.title,
        certification: semanticDocument.agentReady,
        summary,
        manifest: '/ssg-manifest.json',
      };

      Object.defineProperty(window, '__CONSLTR_SEMANTIC_DOM__', {
        configurable: true,
        value: payload,
      });
      document.documentElement.dataset.semanticDom = semanticDocument.standard;
      document.documentElement.dataset.agentReady = semanticDocument.agentReady.level;

      const existingSnapshot = document.getElementById('semantic-dom-runtime');
      const snapshot = existingSnapshot || document.createElement('script');
      snapshot.id = 'semantic-dom-runtime';
      snapshot.setAttribute('type', 'application/json');
      snapshot.textContent = JSON.stringify(payload);
      if (!existingSnapshot) document.head.appendChild(snapshot);
    };

    const frame = window.requestAnimationFrame(publishSemanticDocument);
    return () => window.cancelAnimationFrame(frame);
  }, [parse]);

  return null;
};

export default SemanticDOMBridge;
